const storageKey = (userId: string): string => `upms.account.consent-prompt-dismissed:${userId}`;

export const wasDismissedThisSignIn = (
  userId: string,
  authTime: number | null | undefined
): boolean => {
  if (authTime === undefined || authTime === null) return false;

  try {
    return localStorage.getItem(storageKey(userId)) === String(authTime);
  } catch {
    return false;
  }
};

export const markDismissedThisSignIn = (
  userId: string,
  authTime: number | null | undefined
): void => {
  if (authTime === undefined || authTime === null) return;

  try {
    localStorage.setItem(storageKey(userId), String(authTime));
  } catch {
    // Nothing to recover to — the modal will just show again next reload.
  }
};
